import React from "react";
import ReactDOM from "react-dom";
import "../Model/modal.css";
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

const ConfirmDialog = ({ title, message, handler, isOpen, setIsOpen }) => {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <>
      <div className="custom-modal-backdrop" onClick={() => setIsOpen(false)}></div>
      <div className="custom-modal w-[40%]">
        <div className="custom-modal-content">
          <div className="custom-modal-header">
            <h5 className="custom-modal-title">{title || "Confirmation"}</h5>
            <button className="custom-close-btn" onClick={() => setIsOpen(false)}>
              &times;
            </button>
          </div>

          <div className="custom-modal-body text-center p-4">
            <div className="flex justify-center mb-2">
              <div className="size-12 flex items-center justify-center rounded-full bg-emerald-100">
                <ExclamationTriangleIcon className="size-6 text-orange-600" aria-hidden="true" />
              </div>
            </div>
            <p className="text-lg">{message}</p>
          </div>

          <div className="custom-modal-footer flex justify-center gap-1 p-4">
            <button className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 shadow-xs ring-gray-300 ring-inset hover:bg-gray-50 sm:mt-0 sm:w-auto" onClick={() => setIsOpen(false)}>
              Cancel
            </button>
            <button className="inline-flex w-full justify-center rounded-md bg-emerald-600 px-5 py-2 text-sm font-semibold text-white shadow-xs hover:bg-emerald-500 sm:ml-3 sm:w-auto" onClick={handler}>
              OK
            </button>
          </div>
        </div>
      </div>
    </>,
    document.getElementById("popup-root")
  );
};

export default ConfirmDialog;
